import { create } from 'zustand';

export interface SecurityContextData {
  /** 特权模式 */
  privileged?: boolean;
  /** 允许特权提升 */
  allowPrivilegeEscalation?: boolean;
  /** 根目录只读 */
  readOnlyRootFilesystem?: boolean;
  /** 仅允许非 root 用户运行 */
  runAsNonRoot?: boolean;
  /** 用户 */
  runAsUser?: number;
  /** 用户组 */
  runAsGroup?: number;
  /** SELinux 上下文 */
  seLinuxOptions?: {
    level?: string;
    role?: string;
    type?: string;
    user?: string;
  };
  /** 权能 */
  capabilities?: {
    add?: string[];
    drop?: string[];
  };
}

interface SecurityContextState {
  /** 是否勾选了容器安全上下文 */
  isSecurityContextSelected: boolean;
  /** 容器安全上下文数据 */
  securityContextData?: SecurityContextData;
}

const initState: SecurityContextState = {
  isSecurityContextSelected: false,
  securityContextData: undefined,
};

interface SecurityContextAction {
  toggleSecurityContextSelected: (selected: boolean) => void;
  updateSecurityContextData: (data: SecurityContextData) => void;
  reset: () => void;
}

export const useSecurityContextStore = create<SecurityContextState & SecurityContextAction>()(
  (set) => ({
    ...initState,
    toggleSecurityContextSelected: (selected: boolean) =>
      set({ isSecurityContextSelected: selected }),
    updateSecurityContextData: (data: SecurityContextData) => set({ securityContextData: data }),
    reset: () => set(initState),
  }),
);
